import { render, staticRenderFns } from "./MarketingSiteHeader.vue?vue&type=template&id=0878469c&scoped=true"
import script from "./MarketingSiteHeader.vue?vue&type=script&lang=js"
export * from "./MarketingSiteHeader.vue?vue&type=script&lang=js"
import style0 from "./MarketingSiteHeader.vue?vue&type=style&index=0&id=0878469c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0878469c",
  null
  
)

export default component.exports